export default "__VITE_ASSET__BchofVU9__"